/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, names: NonNullable<unknown> }} Chat_Outlook_Mail_AttachmentsInputs */



/**
* | output |
* | --- |
* | "{count} attachments: {names}" |
*
* @param {Chat_Outlook_Mail_AttachmentsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_outlook_mail_attachments = /** @type {((inputs: Chat_Outlook_Mail_AttachmentsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Outlook_Mail_AttachmentsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Anhänge: ${i?.names}`)
	return /** @type {LocalizedString} */ (`${i?.count} attachments: ${i?.names}`)
});